import { Box, Button, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette } from '../../../shared/components/variables';

export const FilterContainer = styled(Box)`
  display: flex;
  padding: 0.75rem;
  border-radius: 12px;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.625rem;
  align-self: stretch;
  background: ${colorPalette.navy980};
  svg {
    opacity: 0.54;
  }
`;

export const FilterButton = styled(Button)<{ open: boolean; active: boolean }>`
  && {
    &.MuiButton-text {
      border: ${({ open, active }) => (active && !open ? `1px solid ${colorPalette.navy650}` : 'none')};
      color: ${({ open }) => (open ? colorPalette.navy650 : colorPalette.navy300)};
      color: ${({ open, active }) => active && !open && colorPalette.navy650};
      background-color: ${({ open }) => (open ? colorPalette.navy950 : colorPalette.navy980)};
      background-color: ${({ open, active }) => active && !open && colorPalette.navy990};
    }

    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

export const FilterTypeContainer = styled(Box)`
  padding: 0.5rem;
  min-width: 12rem;

  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .filter-options {
    display: inline-flex;
    align-items: start;
  }

  .MuiAutocomplete-endAdornment [data-testid='ArrowDropDownIcon'] {
    display: none;
  }
`;

export const CloseButton = styled(Text)`
  cursor: pointer;
  svg {
    height: 1rem;
    width: 1rem;
    color: ${colorPalette.neutral350};
  }
`;
